export enum MENU {
  HOME = 'home',
  DOCTOR_SUPPORT = 'doctor-support',
  SCANNER = 'scanner',
  EXERCISES = 'exercises',
  MY_ACCOUNT = 'my-account',
  LOGIN = 'login',
}
